import axios from "axios";

const fetcher = async function (url) {
  return await axios.get(url, { "Content-Type": "application/json" });
};

export default fetcher;
